import { render, staticRenderFns } from "./ModalChooseNameContent.vue?vue&type=template&id=86aca144&scoped=true"
import script from "./ModalChooseNameContent.vue?vue&type=script&lang=js"
export * from "./ModalChooseNameContent.vue?vue&type=script&lang=js"
import style0 from "./ModalChooseNameContent.vue?vue&type=style&index=0&id=86aca144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aca144",
  null
  
)

export default component.exports